// 保留两位小数
export function returnFloat(num) {
  // 转成字符串类型  如能确定类型 这步可省去
  num = num.toString()
  if (num.indexOf('.') !== -1) {
    let [integerPart, decimalPart] = num.split('.')
    if (decimalPart.length > 2) {
      decimalPart = decimalPart.substring(0, 2)
    } else if (decimalPart.length === 1) {
      decimalPart += '0'
    }
    num = `${integerPart}.${decimalPart}`
  } else {
    num += '.00'
  }
  return num
}

// 数字则转成K表达
export function numberTransformK(num, locaCode) {
  if (num == 0) {
    return '0'
  }
  // 印尼
  if (locaCode === 'ID') {
    if (typeof num !== 'number' && typeof num !== 'string') {
      return 'NaN'
    }
    const myNum = num * 1
    const kValue = Math.floor((myNum / 1000) * 100) / 100
    // 如果是整数则直接返回
    if (Number.isInteger(kValue)) {
      return `${kValue}K`
    }
    // 非整数
    else {
      // 否则取后两位小数
      return `${kValue.toFixed(2)}K`
    }
  }
  // 非印尼
  else {
    return returnFloat(num)
  }
}

export function decryptCode(str, privateKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPrivateKey(privateKey)
  const data = encrypt.decrypt(str)
  return data
}

export function encryptCode(str, publicKey) {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  const data = encrypt.encrypt(str)
  return data
}

export function getQueryParam(url, paramName) {
  const regex = new RegExp('[?&]' + paramName + '=([^&]*)')
  const match = url.match(regex)
  return match ? decodeURIComponent(match[1]) : null
}

// 随机字符串
export function generateRandomString(length = 8) {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }

  return result
}

// 获取URL中的所有查询参数并返回对象
export function getQueryParams(url) {
  if (!url) return {}

  // 创建一个用于存储参数的对象
  const params = {}

  // 获取问号后面的部分
  const queryString = url.indexOf('?') !== -1 ? url.split('?')[1] : ''

  // 如果没有查询字符串，返回空对象
  if (!queryString) return params

  // 分割查询字符串为键值对数组
  const pairs = queryString.split('&')

  // 遍历每个键值对
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=')
    const key = decodeURIComponent(pair[0])
    const value = decodeURIComponent(pair[1] || '')
    params[key] = value
  }

  return params
}

// 在文件开头添加 deviceId 生成函数
export function createDeviceId() {
  return 'device_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now()
}
